import React from 'react';

const PickerWidget = ({heading,description,image,onSelect,item}) => (
    <li className="list-group-item">
            <div className="media">
                <div className="media-left" style={{verticalAlign:'middle'}}>
                <a className="avatar" style={{width:'40px'}} href="javascript:void(0)">
                    <img className="img-fluid" style={{borderRadius:0}} src="/images/svg/select.svg" alt="..." />
                </a>
            </div>
            <div className="media-body">
                <h4 className="media-heading">
                    {heading}
                </h4>
                <small>{description}</small>
            </div>
            <div className="media-right">
                <button onClick={(e) => {e.stopPropagation(); onSelect(item)}} className="btn btn-dark btn-block">Select</button>
            </div>
        </div>
    </li>
);

export default PickerWidget;




// WEBPACK FOOTER //
// ./components/builder/PickerWidget.js